import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import React from "react";
import {Button} from "@material-ui/core";

const handleDownload = (linkTarget, label, manifestUrl) => {
    const parts = manifestUrl.split('/');
    const astorId = parts[parts.length - 1];

    fetch(linkTarget)
        .then(response => response.blob())
        .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = astorId + "_jpg_" + label + ".jpg";
            link.click();
        })
        .catch(error => console.error('Download failed', error));
}

const ImageLink = ({ height, linkTarget, t, width, label, manifestUrl }) => {
    return (
        <Box
            fontFamily={"Inter"}
            fontSize="0.75rem"
            style={{ alignItems: "center" }}
        >
            JPEG:{" "}
            <Button
                onClick={() => handleDownload(linkTarget, label, manifestUrl)}
                style={{ textDecoration: 'underline', color: '#C8421C', fontSize: '0.75rem', textTransform: 'none', letterSpacing: '0rem', lineHeight: 'normal', verticalAlign: 'baseline' }}
            >
                {`${width} x ${height} ${t("pixels")}`}<i className="fas fa-download" style={{ marginLeft: '4px' }}></i>
            </Button>
        </Box>
    );
};

ImageLink.propTypes = {
    height: PropTypes.number.isRequired,
    linkTarget: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    manifestUrl: PropTypes.string.isRequired,
};

export default ImageLink;
